import styled from 'styled-components'

export const Count = styled.span`
  padding: 0 10px 0;
  height: 21px;
  border-radius: 5px;
  background-color: #e1f2ff;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: normal;
  text-align: center;
  min-width: 35px;
  color: #6d6e71;

  @media (max-width: 768px) {
    right: 0;
    position: absolute;
  }
`

export const FacetContainer = styled.label`
  margin: 0;
  padding: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;

  @media (max-width: 768px) {
    padding-left: 0px;
    position: relative;
  }
`
